export interface Operation {
  id: string;
  quantity: number;
  productId: string;
  description: string;
  amount: number;
  type: string;
  date: Date;
  storeId: string;
}

export enum OperationType {
  ADS = "ADS",
  BUY = "BUY", // For buying products from suppliers
  OTHER_TRANSFER_OUT = "OTHER_TRANSFER_OUT",
  TEAM_SALARY = "TEAM_SALARY",

  TRANSFER_IN = "TRANSFER_IN",
  SELL = "SELL",
}
